var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"nav-link",attrs:{"tag":"td","to":_vm.entry.url}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }